import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-100 text-3xl font-semibold pt-2" }, "Absences", -1)
const _hoisted_3 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_4 = { class: "mb-4 flex justify-start flex-col sm:flex-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "All", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Open", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_absence_table = _resolveComponent("absence-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_app_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAllAbsencesClick())),
            type: "gray",
            class: _normalizeClass(['w-full sm:w-auto border-r-0 rounded-r-none', !_ctx.openAbsences && 'bg-gray-200 hover:bg-gray-200'])
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_app_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOpenAbsencesClick())),
            type: "gray",
            class: _normalizeClass(['w-full sm:w-auto rounded-l-none', _ctx.openAbsences && 'bg-gray-200 hover:bg-gray-200'])
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        (_openBlock(), _createBlock(_component_absence_table, {
          ref: "absenceTable",
          key: _ctx.openAbsences,
          includeNameColumn: true,
          openAbsences: _ctx.openAbsences
        }, null, 8, ["openAbsences"]))
      ])
    ])
  ]))
}